export default "__VITE_ASSET__122030c4__"